import React from 'react';
// core components
import GridContainer from 'components/UI/Grid/GridContainer';
import GridItem from 'components/UI/Grid/GridItem';
import CommandsContainer from 'components/Commands';

const ScreenCommands = () => (
  <GridContainer justify="center">
    <GridItem xs={12} sm={6}>
      <CommandsContainer />
    </GridItem>
  </GridContainer>
);

export default ScreenCommands;
